(function () {
  if (window.AxiomVariantForm) return;

  function getStateMap(state) {
    if (!state) return {};
    return state.variants || state;
  }

  function getVariantState(variant, state) {
    if (!variant) return null;
    return getStateMap(state)[String(variant.id)] || null;
  }

  function getQuantityRule(variant, state) {
    var variantState = getVariantState(variant, state);
    var rule = variantState && variantState.quantityRule ? variantState.quantityRule : (variant && (variant.quantity_rule || variant.quantityRule)) || {};
    return {
      min: Math.max(1, parseInt(rule.min || 1, 10) || 1),
      max: rule.max === null || rule.max === undefined || rule.max === '' ? null : parseInt(rule.max, 10),
      increment: Math.max(1, parseInt(rule.increment || 1, 10) || 1)
    };
  }

  function shouldCheckInventory(variant, state) {
    var variantState = getVariantState(variant, state);
    var inventoryManagement = variantState && variantState.inventoryManagement !== undefined
      ? variantState.inventoryManagement
      : variant && variant.inventory_management;
    var inventoryPolicy = variantState && variantState.inventoryPolicy !== undefined
      ? variantState.inventoryPolicy
      : variant && variant.inventory_policy;
    return inventoryManagement === 'shopify' && inventoryPolicy !== 'continue';
  }

  function getInventoryQuantity(variant, state) {
    var variantState = getVariantState(variant, state);
    if (variantState && variantState.inventoryQuantity !== undefined && variantState.inventoryQuantity !== null) {
      return parseInt(variantState.inventoryQuantity, 10) || 0;
    }
    return parseInt((variant && variant.inventory_quantity) || 0, 10) || 0;
  }

  function variantRequiresSellingPlan(variant, state) {
    var variantState = getVariantState(variant, state);
    if (variantState && variantState.requiresSellingPlan !== undefined) {
      return Boolean(variantState.requiresSellingPlan);
    }
    return Boolean(variant && variant.requires_selling_plan);
  }

  function getSellingPlanAllocations(variant, state) {
    var variantState = getVariantState(variant, state);
    if (variantState && Array.isArray(variantState.sellingPlanAllocations)) {
      return variantState.sellingPlanAllocations;
    }
    if (variant && Array.isArray(variant.selling_plan_allocations)) {
      return variant.selling_plan_allocations;
    }
    return [];
  }

  function getSellingPlanAllocationById(variant, state, sellingPlanId) {
    if (!sellingPlanId) return null;
    return getSellingPlanAllocations(variant, state).find(function (allocation) {
      return String(allocation.sellingPlanId || allocation.selling_plan_id || (allocation.selling_plan && allocation.selling_plan.id) || '') === String(sellingPlanId);
    }) || null;
  }

  function getFirstSellingPlanAllocation(variant, state) {
    var allocations = getSellingPlanAllocations(variant, state);
    return allocations.length ? allocations[0] : null;
  }

  function isSoldOut(variant, state) {
    var variantState = getVariantState(variant, state);
    var available = variantState && variantState.available !== undefined ? variantState.available : variant && variant.available;
    if (!variant || !available) return true;
    return shouldCheckInventory(variant, state)
      && getInventoryQuantity(variant, state) < getQuantityRule(variant, state).min;
  }

  function findAvailableVariantForOptionValue(product, selected, position, value, state) {
    var optionPosition = parseInt(position, 10);
    if (!product || !Array.isArray(product.variants) || !optionPosition) return null;
    return product.variants.find(function (variant) {
      var options = getVariantOptions(variant);
      if (options[optionPosition - 1] !== value || isSoldOut(variant, state)) return false;
      for (var index = 0; index < optionPosition - 1; index += 1) {
        var selectedValue = selected && selected[index + 1];
        if (selectedValue !== undefined && selectedValue !== null && selectedValue !== '' && options[index] !== selectedValue) {
          return false;
        }
      }
      return true;
    }) || null;
  }

  function isOptionValueAvailable(product, selected, position, value, state) {
    return Boolean(findAvailableVariantForOptionValue(product, selected, position, value, state));
  }

  function getEffectiveMaxQty(variant, state) {
    var quantityRule = getQuantityRule(variant, state);
    var variantState = getVariantState(variant, state);
    var cartQuantity = Math.max(0, parseInt(variantState && variantState.cartQuantity, 10) || 0);
    var totalMax = quantityRule.max;
    if (shouldCheckInventory(variant, state)) {
      var inventoryMax = getInventoryQuantity(variant, state);
      totalMax = totalMax === null ? inventoryMax : Math.min(totalMax, inventoryMax);
    }
    return totalMax === null ? null : Math.max(0, totalMax - cartQuantity);
  }

  function getMinimumAddQty(variant, state) {
    var rule = getQuantityRule(variant, state);
    var variantState = getVariantState(variant, state);
    var cartQuantity = Math.max(0, parseInt(variantState && variantState.cartQuantity, 10) || 0);
    return cartQuantity >= rule.min ? rule.increment : rule.min;
  }

  function syncCartQuantity(variant, state, cart) {
    var variantState = getVariantState(variant, state);
    if (!variantState || !cart || !window.AxiomStandardStorefront) return;
    var lines = window.AxiomStandardStorefront.getCartLines(cart);
    variantState.cartQuantity = lines.reduce(function (total, line) {
      var id = line && line.merchandise && line.merchandise.id || line && line.merchandiseId || '';
      return String(id).split('/').pop() === String(variant.id)
        ? total + (parseInt(line.quantity, 10) || 0)
        : total;
    }, 0);
  }

  function normalizeQty(rawValue, variant, state, allowZero) {
    var quantityRule = getQuantityRule(variant, state);
    var min = getMinimumAddQty(variant, state);
    var increment = quantityRule.increment;
    var max = getEffectiveMaxQty(variant, state);
    if (max !== null && max < min) return 0;
    var value = parseInt(rawValue, 10);
    if (!Number.isFinite(value)) value = allowZero ? 0 : min;
    if (allowZero && value <= 0) return 0;
    if (value < min) value = min;
    if (value > min) {
      var remainder = (value - min) % increment;
      if (remainder !== 0) value -= remainder;
    }
    if (max !== null && value > max) {
      value = max;
      if (value >= min) value -= (value - min) % increment;
    }
    if (!allowZero && value < min) value = min;
    return Math.max(allowZero ? 0 : min, value);
  }

  function selectedOptions(root, buttonSelector) {
    var selected = {};
    if (!root || !buttonSelector) return selected;
    root.querySelectorAll(buttonSelector + '.active').forEach(function (button) {
      selected[parseInt(button.dataset.optionPosition, 10)] = button.dataset.value;
    });
    return selected;
  }

  function getVariantOptions(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(function (value) {
      return value !== null && value !== undefined && value !== '';
    });
  }

  function findVariant(product, selected) {
    if (!product || !product.variants) return null;
    if (product.variants.length === 1 && Object.keys(selected || {}).length === 0) {
      return product.variants[0];
    }
    return product.variants.find(function (variant) {
      var options = getVariantOptions(variant);
      if (!options.length) return false;
      return options.every(function (value, index) {
        return selected[index + 1] === value;
      });
    }) || null;
  }

  function getVariantImageUrl(variant, width) {
    if (!variant) return '';
    var featuredImage = variant.featured_image || variant.featuredImage;
    var featuredMedia = variant.featured_media || variant.featuredMedia;
    var previewImage = featuredMedia && (featuredMedia.preview_image || featuredMedia.previewImage);
    var source = featuredImage && (featuredImage.src || featuredImage.url)
      || previewImage && (previewImage.src || previewImage.url)
      || (typeof featuredImage === 'string' ? featuredImage : '');
    if (!source) return '';
    try {
      var url = new URL(source, window.location.origin);
      url.searchParams.set('width', String(width || 120));
      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function getContextualOptionMediaUrl(state, position, optionValueId) {
    var option = (state && state.options || []).find(function (entry) {
      return Number(entry.position) === Number(position);
    });
    if (!option) return '';
    var value = (option.values || []).find(function (entry) {
      return String(entry.id) === String(optionValueId);
    });
    return value && value.mediaUrl ? String(value.mediaUrl) : '';
  }

  function setVariantImageSwatchLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle('is-variant-image-loading', Boolean(isLoading));
    if (isLoading) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  // An image swatch paints no swatch colour underneath, so scaled/anti-aliased
  // edges (cursor parallax) cannot reveal it. The inline translate/scale owned by
  // component-variant-cursor-parallax.js survives the style reset.
  function applyVariantImageSwatchStyle(button, mediaUrl) {
    var translate = button.style.translate;
    var scale = button.style.scale;
    button.style.cssText = mediaUrl ? '' : (button.dataset.swatchFallbackStyle || '');
    if (mediaUrl) {
      button.style.setProperty('--variant-option-image', 'url(' + JSON.stringify(mediaUrl) + ')');
      button.style.setProperty('--swatch-bg', 'transparent');
    }
    if (translate) button.style.translate = translate;
    if (scale) button.style.scale = scale;
    button.dataset.variantImageUrl = mediaUrl;
  }

  function setVariantImageSwatchesLoading(options, isLoading) {
    var root = options && options.root;
    var selector = options && options.buttonSelector;
    if (!root || !selector) return;
    root.querySelectorAll(selector + '[data-variant-image-swatch]').forEach(function (button) {
      setVariantImageSwatchLoading(button, isLoading);
    });
  }

  function syncVariantImageSwatches(options) {
    var root = options && options.root;
    var selector = options && options.buttonSelector;
    if (!root || !selector) return;
    var product = options.product;
    var selected = options.selected || {};
    var contextualState = options.contextualState;

    root.querySelectorAll(selector + '[data-variant-image-swatch]').forEach(function (button) {
      var position = parseInt(button.dataset.optionPosition, 10);
      var mediaUrl = '';

      if (contextualState) {
        mediaUrl = getContextualOptionMediaUrl(contextualState, position, button.dataset.optionValueId);
      } else if (product && Array.isArray(product.variants) && position) {
        var candidateSelection = {};
        Object.keys(selected).forEach(function (key) {
          candidateSelection[key] = selected[key];
        });
        candidateSelection[position] = button.dataset.value;
        mediaUrl = getVariantImageUrl(findVariant(product, candidateSelection), 120);
      }

      var currentMediaUrl = button.dataset.variantImageUrl || '';
      if (mediaUrl === currentMediaUrl) {
        setVariantImageSwatchLoading(button, false);
        return;
      }

      button._variantImageLoadToken = (button._variantImageLoadToken || 0) + 1;
      var loadToken = button._variantImageLoadToken;
      setVariantImageSwatchLoading(button, Boolean(mediaUrl));

      if (!mediaUrl) {
        applyVariantImageSwatchStyle(button, '');
        setVariantImageSwatchLoading(button, false);
        return;
      }

      var image = new Image();
      image.onload = function () {
        if (button._variantImageLoadToken !== loadToken) return;
        applyVariantImageSwatchStyle(button, mediaUrl);
        setVariantImageSwatchLoading(button, false);
      };
      image.onerror = function () {
        if (button._variantImageLoadToken !== loadToken) return;
        applyVariantImageSwatchStyle(button, '');
        setVariantImageSwatchLoading(button, false);
      };
      image.src = mediaUrl;
    });
  }

  function syncQuantityControls(options) {
    var root = options.root || document;
    var variant = options.variant;
    var state = options.state;
    var qtyInput = root.querySelector(options.inputSelector);
    var qtyValue = root.querySelector(options.valueSelector);
    var minus = root.querySelector(options.minusSelector);
    var plus = root.querySelector(options.plusSelector);
    if (!qtyInput || !qtyValue || !variant) return 0;

    var quantityRule = getQuantityRule(variant, state);
    var soldOut = isSoldOut(variant, state);
    var max = getEffectiveMaxQty(variant, state);
    var min = getMinimumAddQty(variant, state);
    var unavailable = soldOut || (max !== null && max < min);
    var nextQty = unavailable ? 0 : normalizeQty(options.keepCurrentValue ? qtyInput.value : min, variant, state, false);

    qtyInput.value = nextQty;
    qtyValue.textContent = nextQty;
    qtyInput.min = min;
    qtyInput.step = quantityRule.increment;
    if (max !== null) qtyInput.max = max;
    else qtyInput.removeAttribute('max');

    if (minus) minus.disabled = unavailable || nextQty <= min;
    if (plus) plus.disabled = unavailable || (max !== null && nextQty >= max);
    if (typeof options.onChange === 'function') options.onChange(variant, nextQty);
    return nextQty;
  }

  // Description blocks of a product whose variants have their own description
  // (product-variant-description-sources): the templates after each target hold
  // every variant's text and the fallback; a block with no text left is hidden.
  function syncVariantDescriptions(root, variantId) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-variant-description-target]').forEach(function (target) {
      var source = null;
      var fallback = null;
      for (var node = target.nextElementSibling; node && node.matches('template[data-variant-description]'); node = node.nextElementSibling) {
        var key = node.getAttribute('data-variant-description');
        if (key === String(variantId)) source = node;
        if (key === 'fallback') fallback = node;
      }
      source = source || fallback;
      if (!source) return;
      target.innerHTML = source.innerHTML;
      var block = target.closest('[data-variant-descriptions]') || target;
      block.style.display = target.textContent.trim() || target.querySelector('img, video, iframe') ? '' : 'none';
    });
  }

  function collectProperties(form) {
    var properties = {};
    if (!form) return properties;
    var formData = new FormData(form);
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (!match) return;
      if (value === '' || value === null || value === undefined) return;
      if (typeof File !== 'undefined' && value instanceof File) return;
      properties[match[1]] = value;
    });
    return properties;
  }

  function formHasFiles(form) {
    if (!form || !form.querySelectorAll) return false;
    return Array.prototype.some.call(form.querySelectorAll('input[type="file"]'), function (input) {
      return input.files && input.files.length;
    });
  }

  window.AxiomVariantForm = {
    getVariantState: getVariantState,
    getQuantityRule: getQuantityRule,
    shouldCheckInventory: shouldCheckInventory,
    getInventoryQuantity: getInventoryQuantity,
    variantRequiresSellingPlan: variantRequiresSellingPlan,
    getSellingPlanAllocations: getSellingPlanAllocations,
    getSellingPlanAllocationById: getSellingPlanAllocationById,
    getFirstSellingPlanAllocation: getFirstSellingPlanAllocation,
    isSoldOut: isSoldOut,
    getEffectiveMaxQty: getEffectiveMaxQty,
    getMinimumAddQty: getMinimumAddQty,
    syncCartQuantity: syncCartQuantity,
    normalizeQty: normalizeQty,
    selectedOptions: selectedOptions,
    getVariantOptions: getVariantOptions,
    findVariant: findVariant,
    findAvailableVariantForOptionValue: findAvailableVariantForOptionValue,
    isOptionValueAvailable: isOptionValueAvailable,
    setVariantImageSwatchesLoading: setVariantImageSwatchesLoading,
    syncVariantImageSwatches: syncVariantImageSwatches,
    syncQuantityControls: syncQuantityControls,
    collectProperties: collectProperties,
    syncVariantDescriptions: syncVariantDescriptions,
    formHasFiles: formHasFiles
  };
})();
